/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Checkbox Service User Denied styled
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const CheckboxServiceUserDeniedStyled = styled.div.attrs(({ disabled }: { disabled: boolean }) => ({
    className: disabled ? 'disabled' : '',
}))<{ disabled: boolean }>`
    display: flex;

    &.disabled {
        color: ${colors.textColorOpacity};
        cursor: auto;
    }
`;
